<div class="modal-header" appCustomAutofocus>
    <h3>Personal Info Update</h3>
</div>
<div class="modal-body">
    <div [hidden]="oNPerInTaskCustomText == null">
        <quill-view [content]="oNPerInTaskCustomText"></quill-view>
    </div>
    <div class="alert alert-danger" *ngIf="isOnboarding && formData.Birthday != null && (formData.Birthday > today)">Date of Birth must not be in the future</div>
    <form #applyForm="ngForm">
        <div style="margin-bottom:10px;" class="row">
            <div class="col-lg-3 col-md-3" style="margin-bottom:5px;">
                <label><strong>First Name</strong></label> <span *ngIf="personalInfoRequire.FirstName" style="color:red;">*</span>
                <input [(ngModel)]="formData.FirstName" class="form-control" type="text" [required]="personalInfoRequire.FirstName" name="FirstName" />
            </div>
            <div class="col-lg-3 col-md-3" style="margin-bottom:5px;">
                <label><strong>Middle Name</strong></label> <span *ngIf="personalInfoRequire.MidName" style="color:red;">*</span>
                <input [(ngModel)]="formData.MidName" class="form-control" type="text" [required]="personalInfoRequire.MidName" name="MidName" />
            </div>
            <div class="col-lg-3 col-md-3" style="margin-bottom:5px;">
                <label><strong>Last Name</strong></label> <span *ngIf="personalInfoRequire.LastName" style="color:red;">*</span>
                <input [(ngModel)]="formData.LastName" class="form-control" type="text" [required]="personalInfoRequire.LastName" name="LastName" />
            </div>
            <div class="col-lg-3 col-md-3" style="margin-bottom:5px;">
                <label><strong>Suffix</strong></label> <span *ngIf="personalInfoRequire.Suffix" style="color:red;">*</span>
                <input [(ngModel)]="formData.Suffix" class="form-control" type="text" [required]="personalInfoRequire.Suffix" name="Suffix" />
            </div>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-3" style="margin-bottom:5px;">
                <label><strong>Email</strong></label> <span *ngIf="personalInfoRequire.Email" style="color:red;">*</span>
                <input [(ngModel)]="formData.Email" class="form-control" type="text" [required]="personalInfoRequire.Email" [ngClass]="{invalidField: (formData.Email != null && formData.Email !== '') && containAt()}" name="Email" />
            </div>

            <div class="col-lg-3 col-md-3" style="margin-bottom:5px;">
                <label><strong>Cell Phone</strong></label> <span *ngIf="personalInfoRequire.Cell" style="color:red;">*</span>
                <input [(ngModel)]="formData.Cell" class="form-control" type="text" appPhoneFormat (valueChange)="updatePhoneAndZip($event,'Cell')" [required]="personalInfoRequire.Cell" placeholder="{{phoneMask}}" (blur)="checkContact('C')" name="Cell" />
            </div>

            <div class="col-lg-3 col-md-3" style="margin-bottom:5px;">
                <label><strong>Other Phone</strong></label> <span *ngIf="personalInfoRequire.Phone" style="color:red;">*</span>
                <input [(ngModel)]="formData.Phone" class="form-control" type="text" appPhoneFormat (valueChange)="updatePhoneAndZip($event,'Phone')" [required]="personalInfoRequire.Phone" placeholder="{{phoneMask}}" (blur)="checkContact('P')" name="Phone" />
            </div>

            <div class="col-lg-2 col-md-2" style="margin-bottom:5px;" *ngIf="!isOnboarding">
                <label><strong>Best Contact</strong></label> <span *ngIf="personalInfoRequire.Contact" style="color:red;">*</span>
                <ng-select [(ngModel)]="formData.Contact"
                           [ngClass]="{'is-invalid': personalInfoRequire.Contact && !formData.Contact}"
                           [required]="personalInfoRequire.Contact"
                           [searchable]="false"
                           [clearable]="false"
                           name="Contact">
                    <ng-option value="C" *ngIf="formData.Cell != null && formData.Cell !== ''">Cell</ng-option>
                    <ng-option value="E">Email</ng-option>
                    <ng-option value="P" *ngIf="formData.Phone != null && formData.Phone !== ''">Phone</ng-option>
                    <ng-option value="M">Mail</ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row" *ngIf="isOnboarding">
            <div class="col-lg-3 col-md-3" style="margin-bottom:5px;">
                <label><strong>Date of Birth</strong></label> <span *ngIf="personalInfoRequire.Birthday" style="color:red;">*</span>
                <div class="input-group">
                    <input type="text" [required]="personalInfoRequire.Birthday"
                           class="form-control"
                           bsDatepicker
                           #dobdp="bsDatepicker"
                           [(ngModel)]="formData.Birthday"
                           [outsideClick]="true"
                           [bsConfig]="datePickerOptions"
                           [readonly]="mobileMode"
                           [ngClass]="{invalidField: formData.Birthday != null && formData.Birthday > today}"
                           style="background-color:#ffffff"
                           name="BirthDay">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                                (click)="dobdp.show()"
                                [attr.aria-expanded]="dobdp.isOpen">
                            <i class="modus-icons align-bottom">calendar</i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-3" style="margin-bottom:5px;">
                <label><strong>Marital Status</strong></label>
                <span *ngIf="personalInfoRequire.MaritalStatus" style="color:red;">*</span>
                <ng-select [(ngModel)]="formData.MaritalStatus"
                           [ngClass]="{'is-invalid': personalInfoRequire.MaritalStatus && !formData.MaritalStatus}"
                           [required]="personalInfoRequire.MaritalStatus"
                           [searchable]="false"
                           [clearable]="false"
                           name="MaritalStatus">
                    <ng-option *ngFor="let data of maritalStatusList" [value]="data.DatabaseValue">{{data.DisplayValue}}</ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-5 col-md-5" style="margin-bottom:5px;">
                <label><strong>Address 1</strong></label> <span *ngIf="personalInfoRequire.Address1" style="color:red;">*</span>
                <input [(ngModel)]="formData.Address1" class="form-control" type="text" [required]="personalInfoRequire.Address1" name="Address1" />
            </div>
            <div class="col-lg-3 col-md-3" style="margin-bottom:5px;">
                <label><strong>Address 2</strong></label> <span *ngIf="personalInfoRequire.Address2" style="color:red;">*</span>
                <input [(ngModel)]="formData.Address2" class="form-control" type="text" [required]="personalInfoRequire.Address2" name="Address2" />
            </div>
            <div class="col-lg-3 col-md-3" style="margin-bottom:5px;">
                <label><strong>City</strong></label> <span *ngIf="personalInfoRequire.City" style="color:red;">*</span>
                <input [(ngModel)]="formData.City" class="form-control" type="text" [required]="personalInfoRequire.City" name="City" />
            </div>
        </div>
        <div class="row">
            <div class="col-lg-2 col-md-2" style="margin-bottom:5px;">
                <label *ngIf="formData.Country === 'US' || formData.Country === 'O' || formData.Country == null"><strong>State</strong></label>
                <label *ngIf="formData.Country === 'CA'"><strong>Province</strong></label>
                <label *ngIf="formData.Country === 'AU'"><strong>State/Territory</strong></label>
                <span *ngIf="personalInfoRequire.State && formData.Country !== 'O'" style="color:red;">*</span>
                <ng-select [(ngModel)]="formData.State"
                           [ngClass]="{'is-invalid': personalInfoRequire.State && formData.Country !== 'O' && !formData.State}"
                           [required]="personalInfoRequire.State && formData.Country !== 'O'"
                           [searchable]="false"
                           [clearable]="false"
                           name="State"
                           [disabled]="formData.Country === 'O'">
                    <ng-option *ngFor="let data of stateList" [value]="data.DatabaseValue">{{data.DisplayValue}}</ng-option>
                </ng-select>
            </div>
            <div class="col-lg-2 col-md-2" style="margin-bottom:5px;">
                <label *ngIf="formData.Country === 'US' || formData.Country === 'O' || formData.Country == null"><strong>Zip</strong></label>
                <label *ngIf="formData.Country === 'CA'"><strong>Postal Code</strong></label>
                <label *ngIf="formData.Country === 'AU'"><strong>Postcode</strong></label>
                <span *ngIf="personalInfoRequire.Zip && formData.Country !== 'O'" style="color:red;">*</span>
                <input [(ngModel)]="formData.Zip" [required]="personalInfoRequire.Zip && formData.Country !== 'O'" [disabled]="formData.Country === 'O'"
                       class="form-control" type="text"
                       [appUSZipFormat]="formData.Country" (valueChange)="updatePhoneAndZip($event,'Zip')" name="Zip" />
            </div>
            <div class="col-lg-5 col-md-5" style="margin-bottom:5px;">
                <div style="display: inline-flex;">
                    <div>
                        <label><strong>Country</strong></label> <span *ngIf="personalInfoRequire.Country" style="color:red;">*</span>
                        <ng-select [(ngModel)]="formData.Country"
                                   [ngClass]="{'is-invalid': personalInfoRequire.Country && !formData.Country}"
                                   [required]="personalInfoRequire.Country"
                                   [searchable]="false"
                                   [clearable]="false"
                                   (ngModelChange)="countryChange()"
                                   name="Country"
                                   style="min-width: 107px;">
                            <ng-option value="US">USA</ng-option>
                            <ng-option value="CA">CANADA</ng-option>
                            <ng-option value="AU">AUSTRALIA</ng-option>
                            <ng-option value="O">OTHER</ng-option>
                        </ng-select>
                    </div>
                    <div style="margin-left: 30px;" *ngIf="formData.Country === 'O'">
                        <label><strong>Other Country</strong></label> <span *ngIf="personalInfoRequire.Country" style="color:red;">*</span>
                        <input class="form-control" type="text" [(ngModel)]="formData.CountryOther" [required]="personalInfoRequire.Country" name="OtherCountry" />
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="sourceList.length > 0 && !isOnboarding">
            <hr />
            <label><strong>How did you hear about us? <span *ngIf="requireReqSourceOnJobReq" style="color:red">*</span></strong></label>
            <div class="row">
                <div class="col-lg-3 col-md-3">
                    <ng-select [(ngModel)]="formData.ContactSource"
                               [ngClass]="{'is-invalid': requireReqSourceOnJobReq && !formData.ContactSource}"
                               [required]="requireReqSourceOnJobReq"
                               [searchable]="true"
                               [clearable]="true"
                               name="ContactSource">
                        <ng-option *ngFor="let data of sourceList" [value]="data.DatabaseValue">{{data.DisplayValue}}</ng-option>
                    </ng-select>
                </div>
                <div class="col-lg-8 col-md-8">
                    <input [(ngModel)]="formData.ContactSourceNotes" type="text" class="form-control" placeholder="Any other details?" [required]="sourceDisplay[formData.ContactSource] === 'Employee Referral'" name="tSourceNotes" />
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="saveClicked()" [disabled]="applyForm.form.invalid || (isOnboarding && formData.Birthday != null && (formData.Birthday > today))">Save</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>